import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";

import { Actions } from "./electrical-products-filter.actions";
import { ElectricalProductsFilterModel } from "./electrical-products-filter.model";

export class ElectricalProductsFilterStateModel extends ElectricalProductsFilterModel {}

@State<ElectricalProductsFilterStateModel>({
  name: "electricalProductsFilter",
  defaults: {
    filter: "*",
  },
})
@Injectable()
export class ElectricalProductsFilterState {
  constructor() {}

  // @Selector()
  // static filter(state: ElectricalProductsFilterStateModel) {
  //   return state.filter;
  // }

  @Action(Actions.Completed)
  completed({ setState }: StateContext<ElectricalProductsFilterStateModel>, { filter }: Actions.Completed) {
    setState({
      filter: filter,
    });
  }
}
